import { Directive, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import {
    blurAutocompleter,
    selectResultByIndex,
    setAutocompleteSelectedIndex,
    setAutocompleteShouldBlur,
    setAutocompleteShowResults,
} from 'SearchApp/ts/features/base-autocomplete/state/autocompleter.actions';

import { CATEGORY_LABELS, CATEGORY_ORDER, SEARCH_TYPES } from 'SearchApp/ts/constants';
import { AutocompleteCategory } from 'SearchApp/ts/types/autocomplete-category.type';
import { AutocompleteStore } from 'SearchApp/ts/features/base-autocomplete/state/interfaces/autocomplete-store.interface';

import { UrlsService } from 'Angular/services/core/urls.service';

/**
 * Search Results Base Directive
 *
 * This class contains common code for components that show the auto completer results.
 * 
 * Inputs:
 * autocompleterId: The UUID that was created by the parent component to manage NgRx state.

 */
@Directive()
export abstract class SearchResultsBaseDirective {
    @Input() autocompleterId!: string;

    inputText: string = '';

    // ----- Constants -----
    CATEGORY_LABELS = CATEGORY_LABELS;

    CATEGORY_ORDER = CATEGORY_ORDER;

    SEARCH_TYPES = SEARCH_TYPES;

    constructor(
        protected urlsService: UrlsService,
        protected readonly store: Store<{ autocompleter: AutocompleteStore }>
    ) {}

    clickResult(): void {
        this.store.dispatch(selectResultByIndex({ autocompleterId: this.autocompleterId }));
    }

    setShouldBlur(shouldBlur: boolean): void {
        this.store.dispatch(setAutocompleteShouldBlur({ autocompleterId: this.autocompleterId, shouldBlur }));
    }

    setSelectedIndex(selectedIndex: number): void {
        // changes selected index on mouseover so highlighted item can be submitted via enter or submit.
        this.store.dispatch(setAutocompleteSelectedIndex({ autocompleterId: this.autocompleterId, selectedIndex }));
    }

    navigateToMoreResultsUrl(category: AutocompleteCategory): void {
        const baseUrl = this.urlsService.SEARCH.SEARCH_ALL_INDEX;
        const queryParams = {
            searchTypes: category === undefined ? [] : [this.SEARCH_TYPES[category]!],
            queryInput: this.inputText,
        };
        this.store.dispatch(setAutocompleteShowResults({ autocompleterId: this.autocompleterId, showResults: false }));
        this.store.dispatch(blurAutocompleter({ autocompleterId: this.autocompleterId }));
        window.location.href = this.urlsService.getUrl(baseUrl, undefined, queryParams);
    }
}
